import News from '../../../api/News';
import * as types from './mutation-types';

export const store = async ({commit}, {params}) => {
    await new News().store(params);
};

export const show = async ({commit}, {id}) => {
    const json = await new News().show(id);

    commit(types.NEWS, json);
};

export const update = async (context, {id, params}) => {
    await new News().update(id, params)
};

export const destroy = async (context, {id}) => {
    await new News().destroy(id)
};

export default {
    store,
    show,
    update,
    destroy,
};



// WEBPACK FOOTER //
// ./src/store/modules/news/actions.js